import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrderTrashComponent } from './order-trash/order-trash.component';
import { AgGridModule } from 'ag-grid-angular';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { GridModule } from '@grid/grid.module';
import { ToolbarModule } from '@toolbar/toolbar.module';
import { NotificationModule } from '@notification/notification.module';
import { InputModule } from '@input/input.module';
import { DataModule } from '@data/data.module';
import { MatTabsModule } from '@angular/material/tabs';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatRadioModule } from '@angular/material/radio';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatSelectModule } from '@angular/material/select';
import { GridCellModule } from '@grid-cell/grid-cell.module';



@NgModule({
  declarations: [
    OrderTrashComponent
  ],
  imports: [
    CommonModule,
    AgGridModule,
    DragDropModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatCardModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatNativeDateModule,
    MatRadioModule,
    MatSelectModule,
    MatTabsModule,
    MatProgressBarModule,
    /* */
    DataModule,
    GridModule,
    GridCellModule,
    InputModule,
    NotificationModule,
    ToolbarModule,
  ],
})
export class TrashModule { }
